import React from "react";
import {
    Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography,
} from "@mui/material";
import { formatMoney } from "../../utils/loyaltyQualification";

function formatWhen(value) {
    return value ? new Date(value).toLocaleString("fr-FR") : "–";
}

function typeChip(row) {
    const type = String(row?.type || "").toUpperCase();
    const expired = row?.isExpired === true || String(row?.status || "").toLowerCase() === "expired";
    const map = {
        EARN: { label: "Gain", bgcolor: "#dcfce7", color: "#166534" },
        DEDUCT: { label: "Retrait", bgcolor: "#fee2e2", color: "#991b1b" },
        EXPIRE: { label: "Expiration", bgcolor: "#FEF3C7", color: "#B45309" },
    };
    const tone = map[type] || { label: type || "–", bgcolor: "#f1f5f9", color: "#334155" };
    return {
        ...tone,
        label: expired && type !== "EXPIRE" ? `${tone.label} (expiré)` : tone.label,
        opacity: expired && type !== "EXPIRE" ? 0.75 : 1,
    };
}

export default function PurchaseMovementsTable({
    movements = [],
    loadError = null,
}) {
    const rows = Array.isArray(movements) ? movements : [];

    return (
        <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 2, border: "1px solid #e8ecf1" }}>
            <Table size="small">
                <TableHead>
                    <TableRow sx={{ backgroundColor: "#fff7ed" }}>
                        <TableCell sx={{ fontWeight: 600, fontSize: 13 }}>Date</TableCell>
                        <TableCell sx={{ fontWeight: 600, fontSize: 13 }}>Type</TableCell>
                        <TableCell sx={{ fontWeight: 600, fontSize: 13 }}>Quantité</TableCell>
                        <TableCell sx={{ fontWeight: 600, fontSize: 13 }}>Montant</TableCell>
                        <TableCell sx={{ fontWeight: 600, fontSize: 13 }}>Expire le</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={5} align="center" sx={{ py: 3, color: "text.secondary", fontStyle: "italic" }}>
                                {loadError || "Aucun mouvement d’achat."}
                            </TableCell>
                        </TableRow>
                    ) : rows.map((row, idx) => {
                        const chip = typeChip(row);
                        return (
                            <TableRow key={row.id || idx} hover sx={{ opacity: chip.opacity }}>
                                <TableCell sx={{ fontSize: 13 }}>{formatWhen(row.created_at || row.createdAt)}</TableCell>
                                <TableCell>
                                    <Chip
                                        size="small"
                                        label={chip.label}
                                        sx={{ fontWeight: 600, fontSize: 11, borderRadius: 1, bgcolor: chip.bgcolor, color: chip.color }}
                                    />
                                </TableCell>
                                <TableCell sx={{ fontSize: 13 }}>{formatMoney(row.quantity ?? 0)}</TableCell>
                                <TableCell>
                                    <Typography fontWeight={700} fontSize={13}>
                                        {formatMoney(row.amount ?? 0)}
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ fontSize: 13 }}>{formatWhen(row.expires_at || row.expiresAt)}</TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
